import React from 'react';
import _ from 'lodash';

import itemDispatchMap from 'go/components/modules/requestDetails/v3/items';
import MoreDetails from 'go/components/modules/requestDetails/v3/MoreDetails';
import {Contexts} from 'componentLibrary';
import {MODES} from 'common/requestDetails/constants';

const {RequestDetailsContext} = Contexts;

export class ItemDispatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openForm: false,
      formError: false,
    };
  }

  static contextType = RequestDetailsContext;

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !_.isEqual(this.state, nextState) ||
      !_.isEqual(_.get(this.props, 'item'), _.get(nextProps, 'item')) ||
      !_.isEqual(this.props.validationErrors, nextProps.validationErrors) ||
      !_.isEqual(this.props.validationDirtyMap, nextProps.validationDirtyMap) ||
      !_.isEqual(
        _.get(this.props, 'itemConfig.itemCode'),
        _.get(nextProps, 'itemConfig.itemCode')
      ) ||
      !_.isEqual(this.props.itemCodeOptions, nextProps.itemCodeOptions) ||
      !_.isEqual(_.get(this.props, 'itemConfig'), _.get(nextProps, 'itemConfig'))
    );
  }

  render() {
    // STATE
    const {
      itemConfig,
      moreDetails: moreDetailsConfig,
      sourcePath,
      tierKey,
      tier,
    } = this.props;

    const mode = _.get(this.context, 'mode');
    const costType =
      _.get(itemConfig, 'costType', null) !== null
        ? itemConfig.costType
        : 'ContainerItem';
    const ErrorComponent = (props) => <div />;
    const ItemDispatched = _.get(itemDispatchMap, [mode, costType], ErrorComponent);
    const newSourcePath = `${sourcePath}.${tierKey}`;
    return (
      <React.Fragment>
        {/* Map to correct cost type, header as default */}
        <ItemDispatched
          {...this.props}
          sourcePath={newSourcePath}
          id={'item-' + _.join(_.split(newSourcePath, '.'), '-')}
          costType={costType}
          mode={mode}
        />
        {_.get(moreDetailsConfig, 'moreDetails') && (
          <MoreDetails
            attachedItemName={_.get(itemConfig, 'name')}
            moreDetailsConfig={_.get(moreDetailsConfig, 'moreDetails')}
            sourcePath={newSourcePath}
            tier={tier}
            mode={mode}
          />
        )}
      </React.Fragment>
    );
  }
}

export default ItemDispatch;
